import { render } from "./BannerImovel.vue?vue&type=template&id=348ac8e4&scoped=true"
import script from "./BannerImovel.vue?vue&type=script&lang=js"
export * from "./BannerImovel.vue?vue&type=script&lang=js"

import "./BannerImovel.vue?vue&type=style&index=0&id=348ac8e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348ac8e4"]])

export default __exports__